// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"660":"d76c3e84","774":"2fc89472","787":"bbba72da","854":"13b8de3d"}[chunkId] + ".chunk.js";
};